'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var median = require('./median.js');
function medianBy(items, getValue) {
    var nums = items.map(function(x) {
        return getValue(x);
    });
    return median.median(nums);
}
exports.medianBy = medianBy;
